//import $ from "jquery";
import debug from "bows";

const linksToAnchors = document.querySelectorAll('a[href^="#"]');

const log = debug("scroll");

export function anchorLinkHandler(e) {
	const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);

	const targetID = this.getAttribute("href");
	const split = targetID.split('#');
	if (split[1] === '') return;
	const targetAnchor = document.querySelector(targetID);
	if (!targetAnchor) return;

	e.preventDefault();
	window.dispatchEvent( new CustomEvent( 'gfi:prehashchange', { detail: { hash: targetID } } ) );

	const originalTop = distanceToTop(targetAnchor);

	let scrollTo = originalTop;

	// give the scroll some padding with the fixed header and sticky in page nav
	const scrollOffset = window.matchMedia('(min-width: 1272px)').matches ? 300 : 150;

	// since we're scrolling up or down adjust negative or positive for the offset
	if ( scrollTo > originalTop ) {
		scrollTo += scrollOffset;
	} else {
		scrollTo -= scrollOffset;
	}

	window.scrollBy({
		top: Math.max( 0, scrollTo ),
		left: 0,
		behavior: "smooth"
	});

	const checkIfDone = setInterval(function () {
		const atBottom =
			window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (distanceToTop(targetAnchor) === 0 || atBottom) {
			targetAnchor.tabIndex = "-1";
			targetAnchor.focus();

			window.history.pushState("", "", targetID);
			window.dispatchEvent( new CustomEvent( 'hashchange' ) ); // let any hashchange event triggers fire
			clearInterval(checkIfDone);
		}
		targetAnchor.addEventListener("blur", function () {
			targetAnchor.removeAttribute('tabIndex');
		});
	}, 100);
}

export function init() {
	log(`scroll init`);
	if (linksToAnchors !== undefined) {
		linksToAnchors.forEach(link => {
			//Exclude links that are in the inpage block
			if ( link.closest('.inpage') ) {
				return;
			}

			// exclude tabs links
			if ( link.classList.contains('tabs__nav-link') ) {
				return;
			}

			link.addEventListener('click', anchorLinkHandler);
		});
	}
}

export default {
	init: init,
	anchorLinkHandler: anchorLinkHandler
};
